<template>
  <div>
    <vxe-grid
      size="small"
      border
      resizable
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="v_tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <!-- <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="optCommand">
            <span class="el-dropdown-link">
              {{ $l('INDEX.choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(opt, index) in tableOpts"
                :key="index"
                :icon="opt.icon"
                :command="{ opt, data: row }"
                :divided="opt.divided"
                :disabled="
                  opt.disabled == undefined ? false : opt.disabled(row)
                "
              >
                {{ opt.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template> -->
      <template v-slot:status="{ row }">
        <div class="status-tag">
          <el-tag effect="dark" size="mini" :type="row.status">
            {{ row.v_status }}
          </el-tag>
        </div>
      </template>
      <template v-slot:userName="{ row }">
        <div v-for="(item, key) in row.userList" :key="key">
          {{
            item.userNo ? `${item.userName}（${item.userNo}）` : item.userName
          }}
        </div>
      </template>
      <template v-slot:yieldRate="{ row }">
        {{ getYieldRate(row) }}
      </template>
      <template v-slot:displayCreate="{ row }">
        <div>{{ row.createByName }}</div>
        <div>{{ row.createTime }}</div>
      </template>
      <template v-slot:displayModify="{ row }">
        <div>{{ row.modifyByName }}</div>
        <div>{{ row.modifyTime }}</div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
import { format, divideDown, multiply } from '@/libs/util.number.js'
import tableColumns from './table-columns'
import tableOpts from './table-opts'
import { cloneDeep } from 'lodash'
import lodash from 'lodash'

export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    issuesList: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      format: (number) => format(number),
      columns: tableColumns(this),
    }
  },
  computed: {
    tableOpts() {
      const opts = tableOpts(this)
      return opts.filter(({ allow }) => (!allow ? true : this.allow(allow)))
    },
    tableColumns() {
      if (
        !this.columns ||
        !this.columns.length ||
        !this.issuesList ||
        !this.issuesList.length
      )
        return []
      const issuesGroup = lodash.mapValues(
        lodash.groupBy(this.issuesList, 'qualityIssuesGroup'),
        (items) => {
          const { qualityIssuesGroup } = items[0]
          return { qualityIssuesGroup, items }
        }
      )
      const _columns = [...this.columns]
      for (const key in issuesGroup) {
        issuesGroup[key].items.forEach((item) => {
          const { qualityIssuesTitle } = item
          _columns.push({
            title: qualityIssuesTitle,
            field: qualityIssuesTitle,
            width: 120,
            align: 'center',
            issues: 'Y',
            showHeaderOverflow: true,
          })
        })
      }
      return _columns
    },
    v_tableData() {
      const v_data = cloneDeep(this.tableData || [])
      v_data.forEach((f) => {
        f.cropping = 0
        f.sewing = 0
        f.material = 0
        f.other = 0
      })

      this.tableColumns.forEach((column) => {
        if (column.issues == 'Y') {
          const { title } = column
          v_data.forEach((f) => {
            const issuesList = f.issuesList || []
            const bool = issuesList?.includes(title)
            f[title] = 0
            if (issuesList?.length > 0) {
              f[title] = issuesList?.filter((item) => item == title).length
            }
            if (bool) {
              this.issuesList.forEach((item) => {
                if (item.qualityIssuesTitle == title) {
                  switch (item.qualityIssuesGroup) {
                    case '裁剪':
                      f.cropping += f[title]
                      break
                    case '缝制':
                      f.sewing += f[title]
                      break
                    case '物料':
                      f.material += f[title]
                      break
                    case '其他':
                      f.other += f[title]
                      break
                  }
                }
              })
            }
          })
        }
      })
      return v_data
    },
  },
  methods: {
    optCommand({ opt, data }) {
      const { menuType } = opt
      const { pendingGoodsQualityCode } = data
      switch (menuType) {
        case 'detail':
        case 'edit':
          this.$emit('openEditPage', {
            pendingGoodsQualityCode,
            menuType,
          })
          break
        case 'delete':
          this.del(data)
          break
        case 'audit':
          this.audit(data)
          break
      }
    },
    getYieldRate({ passQty, checkedQty }) {
      return multiply(divideDown(passQty, checkedQty, 4), 100) + '%'
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  font-size: 12px;
  .el-tag--N {
    color: #91939a;
    background-color: #f4f4f5;
    border: #91939a;
  }

  .el-tag--Y {
    color: #70ce46;
    background-color: #f6ffed;
    border: #b7eb8f;
  }

  .el-tag--N {
    color: #007bff;
    background-color: #e9f3ff;
    border: #007bff;
  }
  .el-tag--R {
    color: #007bff;
    background-color: #e9f3ff;
    border: #007bff;
  }
}
</style>
